import { render, staticRenderFns } from "./CnTermsOfUse.vue?vue&type=template&id=e071e4a6&scoped=true"
import script from "./CnTermsOfUse.vue?vue&type=script&lang=js"
export * from "./CnTermsOfUse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e071e4a6",
  null
  ,true
)

export default component.exports